import { render, staticRenderFns } from "./CompareSimilarProducts.vue?vue&type=template&id=023304b4"
import script from "./CompareSimilarProducts.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompareSimilarProducts.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CompareSimilarProducts.vue?vue&type=style&index=0&id=023304b4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports